module.exports = __webpack_public_path__ + "static/media/SF-2-if-correct.b6821b8b.mp3";